import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import AnalyticsListener from '@/components/AnalyticsListener'
import ScrollToTop from '@/components/ScrollToTop'
import { AppRoutes } from '@/routes'
import '@/globals.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsListener />
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
)
